module.exports = __webpack_public_path__ + "img/Bonifasi.9fc103ac.jpeg";